import ButtonT from '@components/tailwind-components/Button/ButtonT';
import type { HotTopicWithRelatedDTO } from '@conversed/rest/src/contracts/platform-settings/platform-settings.dto';
import { getHotTopicDisplayName } from '@helpers/hotTopicHelper';
import { useModal } from '@hooks/modal/useModal';
import { useTranslation } from 'react-i18next';

export const HotTopicAllModal: React.FC<{
  hotTopics: HotTopicWithRelatedDTO[];
}> = ({ hotTopics }) => {
  const { t } = useTranslation();
  const { hideModal, showModal } = useModal();

  return (
    <div className='tailwind-modal-form flex-1 px-2'>
      <div className='tailwind-modal-body flex flex-col border border-primary-base rounded-md bg-gray-100 px-0 py-0 max-h-[70vh] overflow-hidden'>
        <div className='flex bg-primary-dark text-white text-sm font-normal py-1 px-3 items-center'>
          <span className='font-normal'>
            {t('modals.hot-topic.all.subtitle')}
          </span>
          <span className='ml-1'>({hotTopics.length})</span>
        </div>
        <div className='flex-1 overflow-y-auto p-3 whitespace-pre-wrap word-break-style min-h-[100px] text-xs text-gray-600 gap-1 font-normal'>
          <ul className='list-disc pl-4 flex flex-col gap-1'>
            {hotTopics.map((topic, index) => (
              <li
                key={index}
                className='cursor-pointer hover:text-primary-dark transition-colors'
                onClick={() => {
                  if (topic) {
                    showModal('hot-topic-related-questions', '', {
                      topic,
                      hasBackNavigation: true,
                      onBack: () => {
                        if (hotTopics && hotTopics.length > 0) {
                          showModal('hot-topic-all', '', {
                            hotTopics,
                          });
                        }
                      },
                    });
                  }
                }}>
                {getHotTopicDisplayName(topic.name)}{' '}
                {topic.percentage >= 0 ? `(${topic.percentage}%)` : ''}
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className='tailwind-modal-footer px-0 flex justify-end'>
        <ButtonT
          onClick={hideModal}
          type='button'
          styling='cancel'
          size='xs'
          rounding='md'>
          {t('general.buttons.close')}
        </ButtonT>
      </div>
    </div>
  );
};
